import { render, staticRenderFns } from "./ConcentrationsCreateForm.vue?vue&type=template&id=1c390c14&"
import script from "./ConcentrationsCreateForm.vue?vue&type=script&lang=js&"
export * from "./ConcentrationsCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports